export default {
    dependencies: ['$element', 'settingsservice'],
    callable(element, settingsservice) {
        const input = element.querySelector('input');
        const errorMessage = element.querySelector('[data-error-message]');

        function handleChange() {
            const result = settingsservice.updateFavoritesPush(input.checked);
            result.then(
                () => {
                    errorMessage.classList.add('hidden');
                },
                () => {
                    errorMessage.classList.remove('hidden');
                    input.checked = !input.checked;
                }
            );
        }
        input.addEventListener('change', handleChange);
    },
};



// WEBPACK FOOTER //
// ./controllers/favoritepush.js